// extracted by mini-css-extract-plugin
export var bodyRow = "_dg-d";
export var cardColumns = "_dg-e";
export var ellipsesOverflow = "_dg-2";
export var flatBottomCorners = "_dg-3";
export var flatTopCorners = "_dg-4";
export var headerActionsDropdown = "_dg-f";
export var headerBottomRow = "_dg-c";
export var headerTopRow = "_dg-b";
export var orderDetailsWrapper = "_dg-0";
export var orderInfoContainer = "_dg-1";
export var productDetails = "_dg-9";
export var productImage = "_dg-5";
export var responsiveTable = "_dg-8";
export var shipmentContainer = "_dg-a";
export var tableBottomLeft = "_dg-6";
export var tableBottomRight = "_dg-7";
export var trackingLink = "_dg-g";